<template>
  <div>
    <img src="@/assets/takaku_logo.svg" alt="高く売れるドットコム" class="logo">
    <h1 v-if="templateType === 'info'">お送りいただいた商品の本査定額を<br class="sp_only">お知らせします。
    </h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["page", "code_error", "ispc"])
  },
  props: ["templateType"],
  name: "header-bar"
};
</script>

<style lang="scss" scoped>
#honsatei {
  h1 {
    clear: both;
    font-size: 25px;
    letter-spacing: 1px;
    line-height: 1.5;
    margin: 10px 0 25px 0;
  }
  .content {
    .logo {
      height: 61px;
      position: absolute;
      left: 0;
      top: 10px;
      width: 110px;
    }
  }
}
@media screen and (min-width: 601px) and (max-width: 959px) {
  #honsatei h1 {
    font-size: 18px;
    padding-left: 120px;
    .content .logo {
      left: 10px;
      top: 5px;
    }
  }
}
@media screen and (max-width: 600px) {
  #honsatei {
    h1 {
      font-size: 4.4vw;
      letter-spacing: 0;
      margin: -5px auto 15px 0;
      padding-left: 80px;
    }
    .content {
      .logo {
        height: 43px;
        left: 10px;
        width: 77px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue